
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M6.5 13.5v.688l.866 1.312h2.268l.866-1.312V13.5m-2-7.03V9.5m4-3.567c0-2.493-1.778-4.433-4-4.433s-4 2.032-4 4.433c0 2.402 1.733 4.274 2 5.567h4c.267-1.293 2-3.165 2-5.567"}})])
          )
        }
      }
    